// MUI Imports
import type { Theme } from '@mui/material/styles'

/** Links are interactive: slightly heavier than body text. */
const link: Theme['components'] = {
  MuiLink: {
    styleOverrides: {
      root: {
        fontWeight: 600,
        fontSize: 'inherit',
        lineHeight: 'inherit',
      },
    },
  },
}

export default link
